<template>
  <div style="width: 100%;">
    <div v-if="loading" class="col-12" style="margin-top: 20px;">
      <inline-alert-component message="Gráfico Barras de Ligações Abandonadas..." type="primary"></inline-alert-component>
    </div>

    <div v-else class="card-charts my-3 px-3 py-3">
      <div class="sub-card abandonadas">
        <h3 style="color: #000; text-align: center">
          <i class="fas fa-phone-alt"></i> Ligações Abandonadas
        </h3>
        <hr />
        <apexchart
          id="barChartAbandonedReport"
          type="bar"
          :options="chartOptionsAbandoned"
          :series="seriesAbandoned"
        ></apexchart>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";

export default {
  name: "BarChartAbandonedReport",
  props: {
    filter: {
      type: Object,
      required: true,
      default: () => ({ startDate: "", endDate: "", queue: "*" }),
    },
  },
  data() {
    return {
      loading: false,
      seriesAbandoned: [],
      chartOptionsAbandoned: {
        chart: {
          id: "barChartAbandonedReport",
          type: "bar",
          height: 350,
          stacked: true,
          toolbar: {
            show: true,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            dataLabels: {
              total: {
                enabled: true,
              },
            },
          },
        },
        xaxis: {
          type: "category",
          categories: [],
          labels: {
            formatter: (value) => this.formatDuration(value),
          },
        },
        legend: {
          position: "top",
        },
        fill: {
          opacity: 1,
        },
        noData: {
          text: "Sem dados para exibir no momento...",
        },
        colors: ["#FF4560", "#00E396"],
      },
    };
  },
  methods: {
    getCallsAbandoned() {
      if (!this.filter || !this.filter.startDate || !this.filter.endDate) {
        // Não faz a requisição se filtro incompleto
        return;
      }

      this.loading = true;

      const params = new URLSearchParams({
        startDate: this.filter.startDate,
        endDate: this.filter.endDate,
        queue: this.filter.queue || "*",
      });

      const url = `${window.location.href}/abandonedCallsBarChartReport?${params.toString()}`;

      axios
        .get(url)
        .then(({ data }) => {
          this.seriesAbandoned = [data.maior1MinEspera, data.menor1MinEspera];
          this.chartOptionsAbandoned.xaxis.categories = data.dates;
          this.loading = false;
        })
        .catch((error) => {
          console.error("Erro ao carregar gráfico:", error);
          this.loading = false;
        });
    },
    formatDuration(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YY");
    },
  },
  watch: {
    filter: {
      deep: true,
      immediate: true,
      handler() {
        this.getCallsAbandoned();
      },
    },
  },
};
</script>

<style scoped>
.card-charts {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  width: 100%;
  border-radius: 12px;
  box-shadow: -5px -5px 8px rgba(255, 255, 255, 1),
    -2px -2px 12px rgba(255, 255, 255, 0.5), inset 2px 2px 4px rgba(255, 255, 255, 0.1),
    5px 5px 8px rgba(0, 0, 0, 0.15);
}

.sub-card {
  width: 100%;
}
</style>
